import { render, staticRenderFns } from "./cTabs.vue?vue&type=template&id=0d7bc35a&scoped=true&"
import script from "./cTabs.vue?vue&type=script&lang=js&"
export * from "./cTabs.vue?vue&type=script&lang=js&"
import style0 from "./cTabs.vue?vue&type=style&index=0&id=0d7bc35a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7bc35a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ljz/work-project/bi-base/biDashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d7bc35a')) {
      api.createRecord('0d7bc35a', component.options)
    } else {
      api.reload('0d7bc35a', component.options)
    }
    module.hot.accept("./cTabs.vue?vue&type=template&id=0d7bc35a&scoped=true&", function () {
      api.rerender('0d7bc35a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/cTabs.vue"
export default component.exports